<script setup>
import { Link, usePage, router } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const isImpersonating = computed(() => page.props.auth.isImpersonating);
const authUser = computed(() => page.props.auth.user);
</script>

<template>
    <div v-if="isImpersonating" class="bg-red-500 text-white text-xs text-center py-3 font-semibold fixed top-0 left-0 right-0 z-50 flex justify-between px-16 ">
        <div>Guest admin mode</div>
        <div>You're logged in as a guest admin in the company {{ authUser.companyName }}</div>
        <button @click="router.post(route('logout'))" class="underline">Log out</button>
    </div>
</template> 